export default __webpack_public_path__ + "static/subMenuUpdates-3e07dc0cd6494174a3194ae9e9a4dab1.svg";